export default "__VITE_ASSET__DLlaNUx7__"